import { Typography, TypographyProps } from '@material-ui/core';
import { formatDistanceToNow } from 'date-fns';
import React, { useMemo } from 'react';
import { useSharedTicker } from '../../utils';

interface Props extends TypographyProps {
  prefix?: string;
  lastSeen?: string | Date;
  testId?: string;
  refreshIntervalMs?: number;
}

export function LastSeenDisplay({
  prefix = 'Last seen',
  lastSeen,
  testId,
  refreshIntervalMs,
  ...props
}: Props) {
  const tick = useSharedTicker(refreshIntervalMs);
  const lastSeenDate = useMemo(() => {
    if (!lastSeen) return undefined;

    return lastSeen instanceof Date ? lastSeen : new Date(lastSeen);
  }, [lastSeen]);
  const duration = useMemo(() => {
    if (!lastSeenDate || Number.isNaN(lastSeenDate.getTime())) {
      return null;
    }

    // Recompute when the shared ticker updates so every row stays reasonably fresh.
    void tick;
    const formatted = formatDistanceToNow(lastSeenDate, { addSuffix: true });
    return formatted || 'just now';
  }, [lastSeenDate, tick]);

  if (!duration) {
    return null;
  }

  return (
    <Typography {...props} data-testid={testId}>
      {prefix ? `${prefix} ${duration}` : duration}
    </Typography>
  );
}

export const DurationDisplay = LastSeenDisplay;
